import APIClient from 'src/lib/api-client';
import { getDeviceInfo } from 'src/lib/device';
import { handleSigninData } from 'src/modules/authentication/apis/signin/utils';
import deviceInfoStorage from 'src/modules/authentication/storage/device-info/storage';
import tokenStorage from 'src/modules/authentication/storage/token/storage';
let ensureGuestSessionPromise = null;
let sessionRebootstrapping = false;
export function isSessionRebootstrapping() {
    return sessionRebootstrapping;
}
export function hasValidSession() {
    return Boolean(tokenStorage.getToken() && deviceInfoStorage.getDeviceInfo());
}
export async function ensureGuestSession() {
    if (hasValidSession()) {
        return;
    }
    if (ensureGuestSessionPromise) {
        return ensureGuestSessionPromise;
    }
    ensureGuestSessionPromise = (async () => {
        sessionRebootstrapping = true;
        try {
            const device = await getDeviceInfo();
            const { data } = await APIClient({
                method: 'post',
                url: '/auth/guest/signin',
                data: { device },
            });
            handleSigninData({
                loading: false,
                error: null,
                data,
            });
        }
        finally {
            sessionRebootstrapping = false;
            ensureGuestSessionPromise = null;
        }
    })();
    return ensureGuestSessionPromise;
}
